import React, { useContext, useEffect, useState } from 'react';
import { Box, Flex } from 'rebass/styled-components';

import { UiStateContext } from '../../../shared/contexts/ui-state/UiStateContext';
import { IconPack, Location } from '../../models/app-data-model';
import CardImage from '../card-image/card-image';
import ShIcon from '../sh-icon/sh-icon';
import './location-card-grid-card.scss';

export type LocationCardProps = {
  location: Location;
  cardWidth: number;
  iconPack: IconPack[];
};

const LocationCardGridCard: React.FC<LocationCardProps> = ({ location, cardWidth, iconPack }: LocationCardProps) => {
  const [width, setWidth] = useState<'full-width' | 'half-width' | 'third-width'>();
  const uiStateContext = useContext(UiStateContext);

  useEffect(() => {
    setWidth(cardWidth === 3 ? 'third-width' : cardWidth === 2 ? 'half-width' : 'full-width');
  }, [cardWidth]);

  return (
    <a
      href={location?.website?.href}
      target="_blank"
      rel="noopener noreferrer"
      className={`grid-card location-grid-card ${width}`}
      data-testid={`card-width-${cardWidth}`}
    >
      <Flex className="location-card-grid-card-content">
        <div className="location-pic">
          <CardImage url={location?.photo?.href} alt={location?.title} className={'location-pic-img'} type={'location'} />
        </div>
        <Box className="info-container body-small" ml={3} mr={2} flexGrow={1}>
          <div className="h6 location-name">{location?.title}</div>
          <Flex className={width ? 'left-align hours-info' : 'hours-info'}>
            {location?.hours && (
              <Flex alignItems={'flex-start'}>
                <ShIcon iconPack={iconPack} className="location-card-icon" iconName="clock" />
                <span className="secondary-text">{location?.hours}</span>
              </Flex>
            )}
          </Flex>
          <Flex className="address-info">
            {location?.address?.street_address && (
              <Flex alignItems={'flex-start'}>
                <ShIcon iconPack={iconPack} iconName="map_pin" className="location-card-icon" />
                <span className={width === 'third-width' ? 'address secondary-text' : 'address secondary-text ellipses-overflow'}>
                  {`${location?.address.street_address}, ${location?.address?.city}, ${location?.address?.state} ${location?.address?.zip_code}`}
                </span>
              </Flex>
            )}
            {location?.distance && location?.distance !== 'null' && (
              <div className={width === 'third-width' ? 'distance-container' : 'distance-container ellipses-overflow'}>
                <strong>{location?.distance}</strong> miles away from{' '}
                <span className="address">{uiStateContext?.browserLocation?.latitude === 0 ? 'Grand Rapids' : 'Your Location'}</span>
              </div>
            )}
          </Flex>
        </Box>
      </Flex>
    </a>
  );
};

export default LocationCardGridCard;
